import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'prgov-resend-activate-email',
  templateUrl: './resend-activate-email.component.html',
  styleUrls: ['./resend-activate-email.component.scss']
})
export class ResendActivateEmailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ResendActivateEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    public translate: TranslateService) { }

  ngOnInit() {
  }

  resendCode() {
    if (this.data.type === 2) {
      this.authService.resendEmailConfirm({ Email: this.data.email }).then(data => {
        this.data.type = 3; // Correcto
        this.data.subtitle = this.translate.instant('resendEmail.emailSendingMessage');
        this.data.buttonText = this.translate.instant('resendEmail.backToLogin');
      }, error => {
        this.data.type = 1; // Error
        this.data.subtitle = this.translate.instant('resendEmail.errorTitle');
        this.data.subtitle = this.translate.instant('resendEmail.errorSubtitle');
        this.data.buttonText = this.translate.instant('resendEmail.backToLogin');
      });
    } else {
      this.dialogRef.close();
    }
  }
}
